import { EmployeeDetailsList } from "components/EmployeeDetailsList/EmployeeDetailsList";
import useEmployee from "hooks/useEmployee";

import { ProfileHeader } from "./ProfileHeader/ProfileHeader";

export function EmployeeProfile() {
  const { employeeData } = useEmployee();

  if (!employeeData) return null;

  return (
    <div>
      <ProfileHeader />
      <EmployeeDetailsList />
    </div>
  );
}
